import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  List,
  ListItem,
  ListItemText,
  Button
} from '@mui/material';

export default function ApoyoSelectorDialog({
  open,
  onClose,
  apoyosDisponibles,
  bitacorasPendientesPorApoyo,
  onSelectApoyo
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Múltiples Apoyos Detectados</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          El documento importado contiene más de un tipo de apoyo en los registros. Selecciona cuál de ellos deseas importar:
        </Typography>
        <List>
          {apoyosDisponibles.map(apoyo => (
            <ListItem
              button="true"
              key={apoyo}
              onClick={() => {
                onClose();
                const bitacorasFiltradas = bitacorasPendientesPorApoyo.filter(b => {
                  const val = b.apoyoKms;
                  const strVal = typeof val === 'number' ? val.toString() : String(val || "").trim();
                  return strVal === apoyo;
                });
                onSelectApoyo(bitacorasFiltradas);
              }}
              sx={{ border: '1px solid #eee', mb: 1, borderRadius: 1, cursor: 'pointer' }}
            >
              <ListItemText primary={`Apoyo: ${apoyo}`} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">Cancelar Importación</Button>
      </DialogActions>
    </Dialog>
  );
}
